module.exports = __webpack_public_path__ + "img/google-icon.abba315f.svg";